<template>
  <div class="container">
    <van-tabs v-model="active" animated @change="onActiveChange(active)">
      <van-tab
        v-for="index in chatStatusList"
        :key="index.id"
        :title="getChineseStatus(index.title)"
        :badge="index.num > 0 ? index.num : ''"
      ></van-tab>
    </van-tabs>
    <div class="noOrders" v-if="list.length == 0">
      <div v-if="!firstLoading">
        <div>你还没有消息哦...</div>
      </div>
      <van-loading v-else type="spinner" />
    </div>
    <div v-if="list.length > 0" class="scroll">
      <!-- <van-pull-refresh
        v-model="refreshing"
        @refresh="onRefresh"
        style="height: calc(100% - 10.2vw); overflow: auto"
      > -->
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="到底啦~"
        @load="onLoad"
      >
        <div class="main">
          <div
            class="list"
            id="list"
            v-for="(item, index) in list"
            :key="index"
            @click="onClick(item.id)"
          >
            <div class="flex-row">
              <div class="textCenter">
                {{ item.createTime }}
                <van-badge
                  dot
                  v-if="!item.readStatus"
                  style="margin-bottom: 1.2vw"
                ></van-badge>
              </div>
            </div>
            <div class="keepCenter">
              <div class="keepWidth"></div>
              <div class="center">
                <div class="list_l">{{ item.title }}：</div>
                <div class="shop">{{ item.message }}</div>
              </div>
              <div class="keepWidth"></div>
            </div>
          </div>
        </div>
      </van-list>
      <!-- <van-dialog
        v-model="close"
        confirmButtonText="关闭"
        confirm-button-color="#999999"
        @confirm="onSubmit()"
      >
        <div class="content">
          <div class="flex-between">
            <div class="title">{{ chatContent.title }}</div>
            <div class="timer">{{ chatContent.createTime }}</div>
          </div>

          <div class="message">{{ chatContent.message }}</div>
        </div>
      </van-dialog> -->
      <van-dialog v-model="closeDetail" :showConfirmButton="false">
        <div class="contentDetail">
          <div class="title">{{ chatContent.title }}</div>
          <van-icon
            name="cross"
            color="#c1c1c1"
            class="applyContentIcon"
            @click="onSubmit"
          />
          <div class="message">{{ chatContent.message }}</div>

          <div
            style="margin: 10px 16px 16px"
            @click="onSubmitDetail()"
            v-if="
              chatContent.title == '店长申请通知' ||
              chatContent.title == '销售申请通知'
            "
          >
            <van-button
              type="danger"
              block
              native-type="submit"
              style="border-radius: 8px"
              >去确认</van-button
            >
          </div>
        </div>
      </van-dialog>
      <!-- </van-pull-refresh> -->
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import {
  Tab,
  Tabs,
  Toast,
  Dialog,
  List,
  PullRefresh,
  NavBar,
  Loading,
  Overlay,
  Badge,
} from "vant";
import service from "../../api/user/index";
import loading from "../../components/loading/loading";
export default {
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Toast.name]: Toast,
    // [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Loading.name]: Loading,
    [Badge.name]: Badge,
    [Dialog.Component.name]: Dialog.Component,
    [Overlay.name]: Overlay,
    loading,
  },
  data() {
    return {
      isLoading: true, //loading状态
      active: 0,
      chatStatusList: [],
      MesType: 2,
      close: false,
      closeDetail: false,
      chatContent: {},
      list: [],
      page: 1,
      pageSize: 10,
      reachBottom: false,
      loading: false,
      finished: false,
      // refreshing: false,
      firstLoading: true,
    };
  },
  mounted() {
    this.init();
    this.GetNum();
  },
  methods: {
    getChineseText(e) {
      switch (e) {
        case true:
          return "已读";
        case false:
          return "未读";
        default:
          break;
      }
    },
    onActiveChange(active) {
      this.page = 1;
      this.finished = false;
      this.firstLoading = true;
      this.loading = true;
      if (active == 0) {
        this.MesType = 2;
      } else {
        this.MesType = 1;
      }
      this.list = [];
      this.GetNum();
      this.isLoading = true;
      this.getList().then((list) => {
        this.isLoading = false;
        this.firstLoading = false;
        this.loading = false;
        if (list.items.length !== 0) {
          // list.map((element) => {
          //   element.addTime = parseTime(element.addTime);
          //   element.beginTime = parseTime(element.beginTime);
          //   element.endTime = parseTime(element.endTime);
          // });
          this.list = list.items;
          if (list.totalCount <= this.list.length) {
            this.finished = true;
            this.loading = false;
          }
        } else {
          this.list = [];
        }
      });
    },

    GetNum() {
      service.getMesNum().then((res) => {
        this.isLoading = false;
        res.data.map((v) => {
          if (v.id == 1) {
            v.active = 0;
          } else {
            v.active = 1;
          }
        });
        this.chatStatusList = res.data;
      });
    },
    getChineseStatus(title) {
      switch (title) {
        case "SystemMes":
          return "系统";
        case "CheckMes":
          return "审核";
        default:
          break;
      }
    },
    onLoad() {
      this.page++;
      this.getList().then((list) => {
        this.list = this.list.concat(list.items);
        this.loading = false;
        if (list.totalCount <= this.list.length) {
          this.finished = true;
          this.loading = false;
        }
      });
    },
    init() {
      this.page = 1;
      this.firstLoading = true;
      this.loading = false;
      this.finished = false;
      this.getList()
        .then((list) => {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
          this.list = list.items;
          this.firstLoading = false;
          this.finished = false;
          console.log(list.totalCount, 227);
          if (list.totalCount <= 10) {
            this.finished = true;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    getList() {
      return new Promise((resolve, reject) => {
        service
          .chatlist(this.page, this.pageSize, this.MesType)
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject();
          });
      });
    },
    // onRefresh() {
    //   this.page = 1;
    //   // this.finished = false;
    //   this.loading = true;
    //   this.list = [];
    //   this.isLoading = true;
    //   this.getList().then((list) => {
    //     this.isLoading = false;
    //     this.list = list.items;
    //     this.loading = false;
    //     if (list.totalCount <= this.list.length) {
    //       this.finished = true;
    //     } else {
    //       this.init();
    //     }
    //   });
    //   this.refreshing = false;
    // },
    onClick(id) {
      service.chatDetail(id).then((res) => {
        this.chatContent = res.data;
        // if (res.data.title == "销售申请通知") {
        //   this.closeDetail = true;
        //   return;
        // }
        // if (res.data.title == "店长申请通知") {
        //   this.closeDetail = true;
        //   return;
        // }
        this.closeDetail = true;
      });
      service.chat(id).then(() => {
        // console.log(res.data);
      });
    },
    onSubmit() {
      // this.close = false;
      this.closeDetail = false;
      this.init();
      this.GetNum();
    },
    onSubmitDetail() {
      this.closeDetail = false;
      if (this.chatContent.title == "销售申请通知") {
        this.$router.push({
          name: "salesPerformance",
          query: {
            status: 2,
          },
        });
      }
      if (this.chatContent.title == "店长申请通知") {
        this.$router.push({
          name: "ownerApply",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
@deep: ~">>>";
// .container {
//   width: 100%;
//   height: calc(100% - 0.7vw);
//   overflow-y: scroll;
//   position: fixed;
// }
.container {
  position: fixed;
  height: calc(100% - 0.7vw);
  // min-height: 100vh;
  overflow-y: scroll;
  width: 100%;
  background: #f7f7f7;
  .van-tabs {
    position: fixed;
    width: 100%;
    //代买活动修改
    // top: 0;
    border-bottom: 1px solid #f7f7f7;
  }
  @{deep}.van-tabs--line .van-tabs__wrap {
    height: 13vw;
  }
  .scroll {
    border-top: 1vw solid #f7f7f7;
    // background: #f4f4f4;
    // height: calc(100% - -11.3vw);
    margin-top: 50px;
    // overflow-y: scroll;
  }
}
// :first-child
// @{deep}.van-tabs--line .van-tabs__wrap {
//   height: 9.73333vw;
//   padding: 2vw 0;
//   background: #fff;
// }
@{deep}.van-tab:nth-of-type(1) {
  border-right: 1px solid #c1c1c1;
}
@{deep}.van-tabs__content--animated {
  height: 100%;
}
@{deep}.van-tab__pane,
@{deep}.van-tab__pane-wrapper {
  height: 100%;
}
.noOrders {
  width: 100%;
  text-align: center;
  font-size: 15px;
  color: #92909a;
  padding-top: 30vw;
}

.list {
  margin-bottom: 18.5px;
  border-radius: 4px;
  margin-top: 5 vw;
}
.list_l {
  font-size: 14px;
  margin-bottom: 7px;
}
.timer {
  font-size: 12px;
  color: #a2a2a2;
}

.shop {
  font-size: 13px;
  color: #8d8d8d;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 85.5vw;
}
.content {
  height: 150.5px;
  padding: 22.5px 23px 28.5px;
}
.contentDetail {
  padding-top: 16px;
  position: relative;
  .applyContentIcon {
    position: absolute;
    right: 16px;
    top: 16px;
  }
  .title {
    font-size: 16px;
    font-weight: 600;
    line-height: 16px;
    color: rgba(51, 51, 51, 1);
    text-align: center;
    border-bottom: 1px solid rgba(230, 230, 230, 1);
    padding-bottom: 16px;
  }
  .message {
    margin: 28px 20px;
    line-height: 22px;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
  }
}

</style>
